<template>
  <div class="platform-selector">
    <h3 class="h3">
      Node Mode
    </h3>
    <div class="node-form__tags tags">
      <md-checkbox
        v-model="nodeListExpanded"
        @change="emitListExpandedUpdate"
      >
        Nodes list expanded
        <md-tooltip
          md-direction="top"
          md-delay="300"
        >
          <div class="tooltip-content">
            Used to determine whether to show nodes list to the user.
          </div>
        </md-tooltip>
      </md-checkbox>

      <md-checkbox
        v-model="groupNodesByCountry"
        @change="emitGroupNodesByCountryUpdate"
      >
        Group nodes by country
      </md-checkbox>

      <md-field>
        <label>Node Representation</label>
        <md-select
          v-model="nodeRepresentation"
          @md-selected="emitNodesRepresentationUpdate"
        >
          <md-option value="default_representation">
            default
          </md-option>
          <md-option value="country">
            country
          </md-option>
          <md-option value="custom">
            custom
          </md-option>
          <md-option value="dns_picker">
            dns-picker
          </md-option>
        </md-select>
        <md-tooltip
          md-direction="top"
          md-delay="300"
        >
          <div class="tooltip-content">
            NodeRepresentation shows how to show nodes provided with shortcut
            <ul>
              <li>
                country: country can be used for indicating that the shortcut should show countryname in provided
                node vpn servers. Can be useful 'Countrypicker' shortcuts
              </li>
              <li>custom: get config from custom 'Metadata' in 'Node' entity</li>
            </ul>
          </div>
        </md-tooltip>
      </md-field>
    </div>
  </div>
</template>
<script>
    export default {
        name: "NodesModeSelector",
        props: {
          nodes_list_expanded: Boolean,
          node_representation: { type: String, default: "default_representation" },
          group_nodes_by_country: Boolean
        },
        data() {
            return {
                nodeListExpanded: this.$props.nodes_list_expanded,
                nodeRepresentation: this.$props.node_representation,
                groupNodesByCountry: this.$props.group_nodes_by_country,
            };
        },
        watch: {
            "nodes_list_expanded": "updateListExpandedFromProps",
            "node_representation": "updateRepresentationFromProps",
            "group_nodes_by_country": "updateGroupNodesByCountryFromProps",
        },
        methods: {
            emitListExpandedUpdate() {
                this.$emit("listExpandedUpdate", this.nodeListExpanded);
            },
            emitNodesRepresentationUpdate() {
                this.$emit("representationUpdate", this.nodeRepresentation);
            },
            emitGroupNodesByCountryUpdate() {
                this.$emit("groupNodesByCountryUpdate", this.groupNodesByCountry);
            },
            updateListExpandedFromProps() {
                this.nodeListExpanded = this.$props.nodes_list_expanded || false;
            },
            updateGroupNodesByCountryFromProps() {
                this.groupNodesByCountry = this.$props.group_nodes_by_country || false;
            },
            updateRepresentationFromProps() {
                this.nodeRepresentation = this.$props.node_representation || "default";
            },
        }
    };
</script>
<style lang="scss" scoped>
    .tooltip-content {
        max-width: 100%;
        white-space: normal;
        text-align: left;

        ul {
            padding-left: 4px;
            margin-left: 0;
            max-width: 100%;

            li {
                max-width: 100%;
                white-space: normal;
            }
        }
    }
</style>
